module.exports = __webpack_public_path__ + "resources/shop_icon.0cea920b29e30906.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/shop_icon.png
// module id = 760
// module chunks = 0 2